import { jsonFetch } from './../utils/fetch';
import { urls } from './../config';

// ## Request
// curl -X "POST" "http://localhost:5000/api/v1/auth/register" \
//      -H 'Content-Type: application/json; charset=utf-8' \
//      -d $'{
// "user": {
//   "email": "oleg.chesnokov+test28@gmail.com",
//     "profile": {
//     "phone": "+1234567",
//       "first_name": "Firstname",
//       "last_name": "Lastname"
//   }
// }
// }'
const register = data => jsonFetch(urls.register, data, { method: 'POST' });

// writersandbox

const login = data => jsonFetch(urls.login, data, { method: 'POST' });

const logout = () => jsonFetch(urls.logout, null, { method: 'POST' });

// ## Request (3)
// curl -X "POST" "http://localhost:5000/api/v1/auth/restore_password" \
//      -H 'Content-Type: application/json; charset=utf-8' \
//      -d $'{
// "user": {
//   "email": "oleg.chesnokov+test28@gmail.com"
// }
// }'

const restorePass = (data) => jsonFetch(urls.restore, data, { method: 'POST' });

const requestCode = (data) => jsonFetch(urls.requestCode, data, { method: 'POST' });

// curl -i -X GET \
//    -H "Authorization:Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1MTk4ODU4MjcsImlhdCI6MTUxOTc5OTQyNywic3ViIjo1MX0.Zi2AiqChTKK5NM3AFn9ZREZ1PMe_1kuZ5MCS403IOdo" \
//    -H "Content-Type:application/json" \
//  'http://localhost:5000/api/v1/auth/user'
const user = () => jsonFetch(urls.user);

// user update

// curl -i -X PUT \
//    -H "Authorization:Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MTk4MTk4NjgsInN1YiI6NjksImV4cCI6MTUxOTkwNjI2OH0.uCFFtmVzftIwOpLWAVYYBgbM7kOHdjfaE0_zQkefxiE" \
//    -H "Content-Type:application/json" \
//    -d \
// '{"email": "test@put1.com", "role": "user", "password": "123", "profile": {"first_name": "xy2z", "last_name": "yttt", "new_field": "jsonb!"}, "status": "new", "stage": "email_verification"}' \
//  'http://localhost:5000/api/v1/users/70'

const updateStages = (data) => {
  return jsonFetch(urls.stages, data, { method: 'POST' })
};


// curl -i -X GET \
// -H "Authorization:Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MjAxODgwMDMsInN1YiI6MywiZXhwIjoxNTIwMjc0NDA0fQ.odV877kZUFagBNR8c47B7Nk3KuEoFbUFOwIgvvSRBe8" \
// 'http://localhost:5000/api/v1/tasks?task_type=esse1&page=1&per_page=25'


export const userGeo = () => {
  return fetch(urls.geo).then(resp => {
    if (resp.ok) {
      return resp.json()
    }
  })
}

export default {
  register,
  login,
  logout,
  user,
  updateStages,
  restorePass,
  requestCode,
  userGeo
};



// WEBPACK FOOTER //
// ./src/api/auth.js